import { initializePaddle } from '@paddle/paddle-js';
import { useContext, useEffect, useState } from 'react';
import { PaddlePaymentContext } from '../context/PaddlePaymentContext';
import SynthiAiLogo from '@/common/images/SynthiAi.png';

import {
	LeftInfo,
	PriceWrapper,
	PlanName,
	SaveWrapper,
	TextWrapper,
	Text,
	PriceInfoWrapper,
	Border,
	Title,
	SynthiAiLogoWrapper,
} from '../OneOffPaddlePayment.styles';
import { useLanguageData } from '@/common/hooks/useLanguageData';
import styled from 'styled-components';
import { LanguageContext } from '@/common/contexts/LanguageContext';

const Wrapper = styled.div`
	display: flex;
	justify-content: center;

	@media (max-width: 800px) {
		flex-direction: column;
		align-items: center;
		margin: 0;
	}
`;

const PaymentWrapper = styled.div`
	width: 40vw;
	margin: 35px;

	@media (max-width: 800px) {
		width: 90vw;
		margin: 0px;
	}
`;

const Payment = () => {
	const { transactionId, pickedPlan, promo } = useContext(PaddlePaymentContext);
	const translations = useLanguageData('checkout');
	const { lang } = useContext(LanguageContext);

	const setupPaddle = async () => {
		const paddleToSet = await initializePaddle({
			token: process.env.REACT_APP_PADDLE_CLIENT_TOKEN,
		});

		const spitedLang = lang.split('-');

		paddleToSet.Checkout.open({
			transactionId,
			settings: {
				locale: spitedLang.length > 1 ? spitedLang[1] : lang,
				allowLogout: false,
				displayMode: 'inline',
				frameTarget: 'checkout-container',
				frameInitialHeight: '600',
				frameStyle: `
        width: 100%; 
        min-width: 312px; 
        border: none; 
        font-family: 'Helvetica Neue', sans-serif; 
        font-size: 16px; 
       `,
				successUrl: `https://${window.location.host}/success-payment`,
			},
		});
	};

	useEffect(() => {
		setupPaddle();
	}, []);

	return (
		<Wrapper>
			<LeftInfo>
				<SynthiAiLogoWrapper>
					<img src={SynthiAiLogo} />
				</SynthiAiLogoWrapper>
				<Title>{translations.leftTitle}</Title>
				<div
					style={{
						display: 'flex',
						justifyContent: 'center',
					}}
				>
					<div style={{ minWidth: '320px' }}>
						{pickedPlan && (
							<PriceWrapper style={{ marginBottom: '12px' }}>
								<div
									style={{
										display: 'flex',
										gap: '22px',
										width: 'fit-content',
									}}
								>
									<input
										type='radio'
										id={pickedPlan._id}
										value={pickedPlan._id}
										name='plan'
										checked={pickedPlan._id === pickedPlan?._id}
									/>
									<span
										class='custom-radio-button'
										style={{ marginTop: '5px' }}
									></span>
									<label
										htmlFor={pickedPlan._id}
										style={{
											display: 'flex',
											gap: '22px',
										}}
									>
										<PlanName
											style={{
												color:
													pickedPlan._id === pickedPlan?._id
														? 'linear-gradient(10deg, #48068A 10%, #4322C6 65%)'
														: '#29185E',
											}}
										>
											{pickedPlan.inAppPrice.label}
										</PlanName>{' '}
										<SaveWrapper promo={promo}>
											{promo
												? pickedPlan.inAppPrice.promo_saving
												: pickedPlan.inAppPrice.saving}
										</SaveWrapper>{' '}
									</label>
								</div>
								{pickedPlan._id === pickedPlan?._id && (
									<PriceInfoWrapper>
										<TextWrapper>
											<Text>{pickedPlan.inAppPrice.full_label}</Text>
											<Text>{pickedPlan.inAppPrice.orginal_full_price}</Text>
										</TextWrapper>
										<TextWrapper>
											<Text>
												{promo
													? pickedPlan.inAppPrice.promo_discount_label
													: pickedPlan.inAppPrice.discount_label}
											</Text>
											<Text
												style={{
													color: `${
														promo ? '#149069' : 'var(--pink, #E94F96)'
													}`,
												}}
											>
												{promo
													? pickedPlan.inAppPrice.promo_discount_value
													: pickedPlan.inAppPrice.discount_value}
											</Text>
										</TextWrapper>
										<Border />
										<TextWrapper>
											<Text>{translations.total}</Text>
											<Text>
												<b>
													{' '}
													{promo
														? pickedPlan.promo_full_price
														: pickedPlan.full_price}{' '}
													{translations.currencySign}
												</b>
											</Text>
										</TextWrapper>
									</PriceInfoWrapper>
								)}
							</PriceWrapper>
						)}
					</div>
				</div>
			</LeftInfo>
			<PaymentWrapper>
				<div class='checkout-container' />
			</PaymentWrapper>
		</Wrapper>
	);
};

export default Payment;
